function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import ri from "./trigger-condition.js";

var ur = /*#__PURE__*/function () {
  function ur(t) {
    _classCallCheck(this, ur);

    this.if = t, this.if = t;
  }

  _createClass(ur, [{
    key: "zc",
    value: function zc(t) {
      return null == this.if || ri.sf(t[0], this.if);
    }
  }, {
    key: "bt",
    value: function bt() {
      return this.if;
    }
  }], [{
    key: "fromJson",
    value: function fromJson(t) {
      return new ur(t ? t.campaign_id : null);
    }
  }]);

  return ur;
}();

export { ur as default };